var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import nemWrapper from '../ts/nemWrapper';
import walletModel from '../ts/walletModel';
var Wallet = /** @class */ (function (_super) {
    __extends(Wallet, _super);
    function Wallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.wallet = new walletModel();
        _this.qrSize = 200;
        _this.toAmount = 0;
        _this.toAddr = '';
        _this.message = '';
        _this.validation = [];
        return _this;
    }
    Wallet.prototype.mounted = function () {
    };
    Wallet.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.wallet.getAccount()];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Wallet.prototype.tapSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('tapSend');
                        if (!(this.isValidation() === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wallet.sendNem(this.toAddr, this.toAmount, this.message)];
                    case 1:
                        result = _a.sent();
                        console.log('tapSend', result);
                        message = '送金しました';
                        if (result.message !== 'SUCCESS') {
                            message = "Error " + result.message;
                        }
                        Vue.prototype.$toast(message);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Wallet.prototype.isValidation = function () {
        this.validation = [];
        this.validation.push(this.$data.rules.senderAddrLimit(this.toAddr));
        this.validation.push(this.$data.rules.senderAddrInput(this.toAddr));
        this.validation.push(this.$data.rules.amountLimit(this.toAmount));
        this.validation.push(this.$data.rules.amountInput(this.toAmount));
        this.validation.push(this.$data.rules.messageRules(this.message));
        console.log(this.validation);
        var isError = false;
        this.validation.forEach(function (obj) {
            if (obj !== true) {
                isError = true;
            }
        });
        return !isError;
    };
    Wallet = __decorate([
        Component({
            name: 'wallet',
            data: function () { return ({
                nem: new nemWrapper(),
                qrJson: '',
                rules: {
                    senderAddrLimit: function (value) { return (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。'; },
                    senderAddrInput: function (value) {
                        var pattern = /^[a-zA-Z0-9-]+$/;
                        return pattern.test(value) || '送金先の入力が不正です';
                    },
                    amountLimit: function (value) { return (value >= 0) || '数量を入力してください'; },
                    amountInput: function (value) {
                        var pattern = /^[0-9.]+$/;
                        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です';
                    },
                    messageRules: function (value) { return (value.length <= 1024) || 'メッセージの最大文字数が超えています。'; }
                }
            }); },
            watch: {
                'wallet.address': function (newVal, oldVal) {
                    this.$data.qrJson = this.$data.nem.getQRcodeJson('2', 2, '', newVal, 0, '');
                }
            }
        })
    ], Wallet);
    return Wallet;
}(Vue));
export default Wallet;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Wallet.vue
// module id = 132
// module chunks = 1